import { Link } from "react-router-dom";
import { Linkedin, Twitter, Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: "About", href: "/#about" },
      { label: "Services", href: "/services" },
      { label: "Industries", href: "/industries" },
      { label: "Process", href: "/#process" },
      { label: "Contact", href: "/#contact" },
    ],
    services: [
      { label: "Custom Software", href: "/services#custom-software" },
      { label: "AI Integrations", href: "/services#ai-integration" },
      { label: "ML & Deep Learning", href: "/services#custom-ai-ml" },
      { label: "Generative AI", href: "/services#generative-ai" },
      { label: "AI Agents & Automation", href: "/services#ai-automation" },
      { label: "Computer Vision", href: "/services#computer-vision" },
    ],
    legal: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms & Conditions", href: "#" },
      { label: "Cookie Policy", href: "#" },
    ],
  };

  return (
    <footer
      className="bg-void border-t border-white/10 pt-16 pb-8"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-4 lg:col-span-2">
            <Link to="/" className="font-unbounded font-bold text-2xl text-white">
              GuruTech<span className="text-electric-violet">AI</span>
            </Link>
            <p className="text-muted-foreground mt-4 max-w-sm leading-relaxed">
              Your end-to-end AI solutions partner. We build custom AI products,
              automation systems, and intelligent platforms that scale businesses.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.linkedin.com/company/gurutech-ai"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-muted-foreground hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://x.com/GuruTechAI"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-muted-foreground hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="mailto:info@gurutechai.com"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-muted-foreground hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-unbounded font-medium text-white mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-unbounded font-medium text-white mb-4">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-unbounded font-medium text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-muted-foreground hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} GuruTech AI. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground" data-testid="founder-credit">
            Founded by{" "}
            <span className="text-white font-medium">Suyash Saxena</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
